import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-body-1" }, "Шаг 2. Заполните данные о себе", -1)

import { ref, computed } from 'vue'
import { ControlQuestionsService, ControlQuestion, MunicipalEntitiesService } from '@prodcard/core'
import { createCtx, handleError, useWatcherSavedRef } from '../../../helpers'
import { useVuelidate, ErrorObject } from '@vuelidate/core'
import { required, helpers, sameAs } from '@vuelidate/validators'
import { VPasswordField, VPhoneField, VMunicipalEntitiesSelect } from '../../../components'
import { RegisterUserOpts } from './interfaces'


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationUserForm',
  props: {
    controlQuestionsService: {},
    municipalEntitiesService: {},
    defaultOpts: {},
    loading: { type: Boolean, default: false }
  },
  emits: ["submit", "back"],
  setup(__props: any, { emit }) {

const props = __props;





const opts = useWatcherSavedRef<RegisterUserOpts>('RegisterUserOpts', {
  surname: '',
  name: '',
  patronymic: '',
  phone: '',
  password: '',
  controlQuestionId: '',
  controlAnswer: '',
  municipalEntityId: '',
  ...props.defaultOpts,
})
const passwordConfirmation = useWatcherSavedRef('passwordConfirmation', '')
const controlQuestions = ref<ControlQuestion[]>([])
const loadingQuestions = ref(false)

handleError(async () => {
  const response = await props.controlQuestionsService.findAll(createCtx())
  controlQuestions.value = response
}, loadingQuestions)

const rules = computed(() => ({
  surname: {
    required: helpers.withMessage('Фамилия не может быть пустой', required),
  },
  name: {
    required: helpers.withMessage('Имя не может быть пустым', required),
  },
  phone: {
    validator: helpers.withMessage('Контактный телефон некорректен', () => {
      if (!opts.value.phone) return true

      return opts.value.phone.length === 11
    }),
  },
  password: {
    required: helpers.withMessage('Пароль не может быть пустым', required),
    sameAs: helpers.withMessage('Пароли не совпадают', sameAs(passwordConfirmation)),
  },
  controlQuestionId: {
    required: helpers.withMessage('Контрольный вопрос не может быть пустым', required),
  },
  controlAnswer: {
    required: helpers.withMessage('Ответ на контрольный вопрос не может быть пустым', required),
  },
  municipalEntityId: {
    required: helpers.withMessage('Муниципальное образование не может быть пустым', required),
  },
}))

const validator = useVuelidate<RegisterUserOpts>(rules, opts)

const submit = async () => {
  const valid = await validator.value.$validate()

  if (valid) emit('submit', opts.value)
}

const getErrorMessages = (errors: ErrorObject[]) => {
  return errors.map((e: ErrorObject) => e.$message).join()
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    onSubmit: _withModifiers(submit, ["prevent"]),
    disabled: _ctx.loading
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _unref(opts).surname,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(opts).surname) = $event)),
                "error-messages": getErrorMessages(_unref(validator).surname.$errors),
                label: "Фамилия*"
              }, null, 8, ["modelValue", "error-messages"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _unref(opts).name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(opts).name) = $event)),
                "error-messages": getErrorMessages(_unref(validator).name.$errors),
                label: "Имя*"
              }, null, 8, ["modelValue", "error-messages"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _unref(opts).patronymic,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(opts).patronymic) = $event)),
                label: "Отчество"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(VPhoneField), {
                phone: _unref(opts).phone,
                "onUpdate:phone": _cache[3] || (_cache[3] = ($event: any) => ((_unref(opts).phone) = $event)),
                label: "Телефон",
                "error-messages": getErrorMessages(_unref(validator).phone.$errors)
              }, null, 8, ["phone", "error-messages"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(VPasswordField), {
                modelValue: _unref(opts).password,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(opts).password) = $event)),
                "error-messages": getErrorMessages(_unref(validator).password.$errors),
                label: "Пароль*"
              }, null, 8, ["modelValue", "error-messages"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(VPasswordField), {
                modelValue: _unref(passwordConfirmation),
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(passwordConfirmation) ? (passwordConfirmation).value = $event : null)),
                "error-messages": 
            _unref(validator).password.sameAs.$invalid && _unref(validator).password.$dirty
              ? _unref(validator).password.sameAs.$message
              : undefined
          ,
                label: "Подтвердите пароль"
              }, null, 8, ["modelValue", "error-messages"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_select, {
                "model-value": _unref(opts).controlQuestionId || undefined,
                items: controlQuestions.value,
                loading: loadingQuestions.value,
                "error-messages": getErrorMessages(_unref(validator).controlQuestionId.$errors),
                label: "Контрольный вопрос*",
                "item-title": "question",
                "item-value": "id",
                "no-data-text": "Нет данных",
                clearable: "",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = id => (_unref(opts).controlQuestionId = id ?? ''))
              }, null, 8, ["model-value", "items", "loading", "error-messages"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _unref(opts).controlAnswer,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(opts).controlAnswer) = $event)),
                label: "Ответ на контрольный вопрос*",
                "error-messages": getErrorMessages(_unref(validator).controlAnswer.$errors)
              }, null, 8, ["modelValue", "error-messages"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(VMunicipalEntitiesSelect), {
                "model-value": _unref(opts).municipalEntityId || undefined,
                "municipal-entities-service": _ctx.municipalEntitiesService,
                "error-messages": getErrorMessages(_unref(validator).municipalEntityId.$errors),
                disabled: _ctx.loading,
                label: "Муниципальное образование*",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = id => (_unref(opts).municipalEntityId = id ?? ''))
              }, null, 8, ["model-value", "municipal-entities-service", "error-messages", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { justify: "end" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "outlined",
                color: "primary",
                disabled: _ctx.loading,
                onClick: _cache[9] || (_cache[9] = ($event: any) => (emit('back')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Назад ")
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_v_btn, {
                type: "submit",
                color: "primary",
                loading: _ctx.loading,
                class: "ml-6"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Далее ")
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onSubmit", "disabled"]))
}
}

})